export default [
    {
        path: '/communication',
        name: 'CommunicationIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Templates',
        },
        components: {
            default: () => import('@views/communication/CommunicationsIndex.vue'),
        },
    },
    {
        path: '/communication/create',
        name: 'CommunicationCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create communication template',
        },
        props: {
            default: () => ({ isCreate: true }),
        },
        components: {
            default: () => import('@views/communication/CommunicationsForm.vue'),
        },
    },
    {
        path: '/communication/:id/edit',
        name: 'CommunicationEdit',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit communication template',
        },
        props: {
            default: () => ({ isCreate: false }),
        },
        components: {
            default: () => import('@views/communication/CommunicationsForm.vue'),
        },
    },
];
